import { render, staticRenderFns } from "./SpringFrame.vue?vue&type=template&id=570e6cb2&scoped=true&"
import script from "./SpringFrame.vue?vue&type=script&lang=js&"
export * from "./SpringFrame.vue?vue&type=script&lang=js&"
import style0 from "./SpringFrame.vue?vue&type=style&index=0&id=570e6cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e6cb2",
  null
  
)

export default component.exports